import { ShieldCheck, MessageCircle, PackageCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const MACRO = "https://images.unsplash.com/photo-1695823018812-c684c980ede6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

const Tile = ({ icon: Icon, title, text, className = "", delay = 0, testid }) => (
  <Reveal delay={delay} className={`group rounded-[28px] border border-white/10 bg-[#111113] p-7 sm:p-9 flex flex-col justify-between gap-10 transition-colors duration-500 hover:border-white/25 ${className}`} data-testid={testid}>
    <Icon className="h-7 w-7 text-white transition-transform duration-700 group-hover:-rotate-12 group-hover:scale-110" strokeWidth={1.4} />
    <div>
      <h3 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">{title}</h3>
      <p className="mt-3 text-zinc-400 leading-relaxed">{text}</p>
    </div>
  </Reveal>
);

const STEPS = ["Escolha o aparelho na vitrine", "Toque em “Tenho interesse” ou monte seu carrinho", "Combine pagamento e entrega com a gente"];

export const WhyBuy = () => (
  <section id="por-que" data-testid="why-buy-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 pb-24 sm:pb-36">
    <Reveal>
      <Eyebrow>(02) — Por que a RC</Eyebrow>
      <h2 className="font-display mt-5 max-w-4xl text-5xl sm:text-6xl lg:text-7xl font-extrabold tracking-[-0.04em] text-white leading-[0.95]">
        Simples como deveria <span className="text-outline">ser.</span>
      </h2>
    </Reveal>

    <div className="mt-14 grid grid-cols-1 gap-4 lg:grid-cols-12 lg:auto-rows-[minmax(260px,auto)]">
      <Reveal className="relative overflow-hidden rounded-[28px] border border-white/10 min-h-[420px] lg:col-span-7 lg:row-span-2" data-testid="why-tile-stock">
        <img src={MACRO} alt="Detalhe das câmeras de um iPhone" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1600ms] hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
        <div className="absolute bottom-0 p-7 sm:p-10">
          <PackageCheck className="h-7 w-7 text-white" strokeWidth={1.4} />
          <h3 className="font-display mt-6 text-3xl sm:text-4xl font-bold tracking-tight text-white">Vitrine sempre real</h3>
          <p className="mt-3 max-w-md text-zinc-200 leading-relaxed">Vendeu, saiu do site. O que você vê aqui é o que temos para te entregar.</p>
        </div>
      </Reveal>
      <Tile testid="why-tile-warranty" className="lg:col-span-5" delay={0.08} icon={ShieldCheck} title="Garantia de verdade" text="Novo • Lacrado (Americano): 1 ano de garantia Apple. Seminovos com 4 meses de garantia. Na HPrime: fontes e cabos com 3 anos; películas e capas com 3 meses contra defeitos de fábrica — e acessórios selecionados com 6 meses de cobertura contra quebra acidental." />
      <Tile testid="why-tile-chat" className="lg:col-span-5" delay={0.16} icon={MessageCircle} title="Fala direto com a gente" text="Sem cadastro e sem pagar no site. Monte seu pedido e finalize no WhatsApp, direto com quem vende o aparelho." />
      <Reveal className="lg:col-span-12 rounded-[28px] border border-white/10 bg-white text-black p-7 sm:p-10" data-testid="why-tile-steps">
        <p className="mono text-xs uppercase tracking-[0.28em] text-zinc-600">Como comprar</p>
        <ol className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <li key={s} className="flex items-baseline gap-4 border-t border-black/15 pt-5">
              <span className="font-display text-5xl font-extrabold tracking-tighter">{i + 1}</span>
              <span className="text-lg font-medium leading-snug">{s}</span>
            </li>
          ))}
        </ol>
      </Reveal>
    </div>
  </section>
);
